const KEY = '@trpc/bearerToken';

export default class AuthenticationTokenManager {
  static get() {
    return Promise.resolve(sessionStorage.getItem(KEY));
  }

  static set(token) {
    sessionStorage.setItem(KEY, token);
    return Promise.resolve();
  }

  static remove() {
    sessionStorage.removeItem(KEY);
    return Promise.resolve();
  }
}
